export const aboutComparisonZh = {
  'about.problem.requires': '需要：',
  'about.problem.onlyfans.body': '月入1万美元的创作者每年因手续费损失2.4万美元。',
  'about.problem.onlyfans.requires': '银行账户 + KYC',
  'about.problem.throne.body': '还有货币兑换。还有提现延迟。仅限10个国家。',
  'about.problem.throne.requires': '银行账户 + KYC',
  'about.problem.linktree.body': '或每月支付40美元获得0%手续费。无论如何，他们都在拿走你的钱。',
  'about.problem.linktree.requires': '银行账户 + 支付处理器',
  'about.problem.kickstarter.body': '还有5千至2.5万美元的履行成本。全有或全无融资。',
  'about.problem.kickstarter.requires': '银行账户 + KYC + 履行',
  'about.problem.indiegogo.body': '交付前扣留5%。14天付款延迟。灵活但昂贵。',
  'about.problem.indiegogo.requires': '银行账户 + KYC + 履行',
  'about.problem.katoa.body': '无手续费。无延迟。至2026年12月31日保留100%。',
  'about.problem.katoa.requires': '无需银行账户。无需KYC。',
  'about.problem.avgLoss': '普通创作者损失',
  'about.problem.avgLossAmount': '每年1.2万-2.4万美元',
  'about.problem.allRequire': '所有5个平台都需要：',
  'about.problem.bankAccount': '银行账户',
  'about.problem.kyc': 'KYC验证',
  'about.problem.processors': '支付处理器',
  'about.problem.geoLimits': '地理限制',
  'about.problem.katoaRequires': 'KATOA需要：无',
  'about.problem.katoaWallet': '只需一个Bitcoin Lightning钱包。仅此而已。',
  'about.solution.title': '我们的解决方案：Bitcoin + 去中心化',
  'about.solution.subtitle': '我们基于使平台手续费成为不可能的技术构建了KATOA。',
  'about.solution.lightning.title': 'Lightning Network',
  'about.solution.lightning.body': 'Bitcoin的Lightning Network在闪电收款上线后，实现全球快速、低成本的交易（Roadmap: 进行中）。没有抽成的支付处理器。没有7天延迟。没有地理限制。',
  'about.solution.lightning.item1': '不到1秒结算',
  'about.solution.lightning.item2': '覆盖195个以上国家',
  'about.solution.lightning.item3': '低至聪的微支付',
  'about.solution.lightning.item4': '无需银行账户',
  'about.solution.nostr.title': 'Nostr协议',
  'about.solution.nostr.body': '使审查不可能的去中心化社交协议。你的账户、你的数据、你的规则。没有公司能封禁你或收集你的信息。',
  'about.solution.nostr.item1': '无账户封禁（你拥有密钥）',
  'about.solution.nostr.item2': '可选加密消息（NIP-17）',
  'about.solution.nostr.item3': '零知识支付证明（路线图）',
  'about.solution.nostr.item4': '分布在全球中继节点',
  'about.solution.result.title': '结果：手续费0%（至2026年12月31日）',
  'about.solution.result.body': '当支付在Bitcoin上点对点流动时，没有中间商抽取手续费。这不是促销费率。这是技术的运作方式。',
  'about.values.title': '我们的立场',
  'about.values.creators.title': '创作者优先',
  'about.values.creators.desc': '每个决定都优先保障创作者的收入和自由。',
  'about.values.privacy.title': '始终隐私',
  'about.values.privacy.desc': '最少采集。非托管支付。密钥归你。',
  'about.values.global.title': '真正全球',
  'about.values.global.desc': '无地理歧视。Bitcoin为每个人在各地运作。',
  'about.values.censorship.title': '抗审查',
  'about.values.censorship.desc': '设计上去中心化。没有公司能封禁你或控制你的内容。',
  'about.competitors.title': '为什么每个竞争对手都不达标',
  'about.competitors.subtitle': '它们都有同样的根本缺陷：依赖传统银行系统。',
  'about.competitors.onlyfans.title': 'OnlyFans：20%平台税',
  'about.competitors.onlyfans.body': '月入1万美元的创作者每月损失2000美元（年2.4万）。还有Mastercard/Visa审查风险。还有无法申诉的账户封禁。',
  'about.competitors.kickstarter.title': 'Kickstarter：履行噩梦',
  'about.competitors.kickstarter.body': '平台5% + 支付处理（合计通常约8–10%），外加5千至2.5万美元以上的履约成本。未达目标则得0美元。',
  'about.competitors.indiegogo.title': 'Indiegogo：隐藏扣留',
  'about.competitors.indiegogo.body': '总费用8-15%，包括交付前5%扣留。灵活融资听起来不错，直到他们扣住你的钱。',
  'about.competitors.linktree.title': 'Linktree：付费才能赢',
  'about.competitors.linktree.body': '免费层：10%手续费。或每月40美元（年480美元）获得0%。无论如何，仅为一个落地页就要亏钱。',
  'about.competitors.throne.title': 'Throne：0%怎么算',
  'about.competitors.throne.body': '宣传「0%手续费」，但合计通常约10%。真正的0%仅约10个国家有效；其余需支付差额。',
  'about.competitors.con.bankKyc': '需要银行账户 + KYC',
  'about.competitors.con.payout7': '7天付款延迟',
  'about.competitors.con.payout14': '14天以上付款延迟',
  'about.competitors.con.censorship': '支付处理器审查',
  'about.competitors.con.countries': '限于支持的国家',
  'about.competitors.con.fulfillment': '发货/履行压力',
  'about.competitors.con.oneTime': '仅一次性融资',
  'about.competitors.con.holdback': '产品交付前扣留5%',
  'about.competitors.con.fulfillmentReq': '需要履行',
  'about.competitors.con.processor': '需要支付处理器',
  'about.competitors.con.geoRestrict': '地理限制',
  'about.competitors.con.feesOrSub': '9-10%手续费或年480美元',
  'about.competitors.con.countries50': '限于50个国家',
  'about.competitors.con.withdraw7': '7天提现延迟',
  'about.competitors.con.countries10': '0%限于10个国家',
  'about.competitors.con.conversion': '隐藏的货币兑换费',
  'about.competitors.katoa.title': 'KATOA：唯一真正的替代',
  'about.competitors.katoa.body': 'Lightning路由/网络费用由支持者支付。我们会在该期限结束前公布任何变更。',
  'about.competitors.katoa.fee': '平台费用0%（至2026年12月31日）',
  'about.competitors.katoa.feeDesc': '由Give A Bit和社区支持承担',
  'about.competitors.katoa.payout': '快速付款（路线图）',
  'about.competitors.katoa.payoutDesc': '通过Lightning — 一旦接收功能上线（路线图：进行中）。',
  'about.competitors.katoa.bank': '✓ 无需银行',
  'about.competitors.katoa.bankDesc': '只需Lightning钱包。',
  'about.competitors.katoa.global': '✓ 195个以上国家',
  'about.competitors.katoa.globalDesc': '各地同等运作。',
  'about.audience.title': '我们服务谁',
  'about.audience.subtitle': 'KATOA为传统平台忽视的创作者而建。',
  'about.audience.unbanked.title': '无银行账户者',
  'about.audience.unbanked.body': '阿根廷、尼日利亚、委内瑞拉、越南的创作者。Stripe和PayPal无法运作的国家。',
  'about.audience.unbanked.stat': '支持195个以上国家',
  'about.audience.privacy.title': '注重隐私者',
  'about.audience.privacy.body': '拒绝被监视的创作者。想要端到端加密。要求数据主权。',
  'about.audience.privacy.stat': '最少数据、非托管',
  'about.audience.ambitious.title': '有抱负者',
  'about.audience.ambitious.body': '月入1万至10万美元以上、厌倦损失10-20%手续费的创作者。',
  'about.audience.ambitious.stat': '每年节省1.2万-24万美元',
  'about.team.title': '由创作者打造，为创作者服务',
  'about.team.body1': '我们是一群厌倦向平台损失10-20%收入的创作者团队。所以我们打造了更好的东西。',
  'about.team.body2': '我们没有风投支持。我们不回应要求不惜代价增长的投资人。我们回应创作者。因此我们永不收费。',
  'about.team.promise': '我们的承诺',
  'about.team.promise1': '我们永不收取平台手续费',
  'about.team.promise2': '我们永不收集你的数据',
  'about.team.promise3': '我们永不因合法内容封禁创作者',
  'about.team.promise4': '我们始终将你的收入置于我们之上',
  'about.cta.title': '加入运动',
  'about.cta.subtitle': '仍处早期。加入即可保留100%收入——平台手续费0%（至2026年12月31日）。',
  'about.cta.highlight': '下一个就是你。',
  'about.cta.start': '开始赚取100%',
  'about.cta.compare': '查看数据',
  'about.cta.footer': '无手续费。无KYC。无陷阱。只有你保留100%。',
  'comparison.badge': '诚实对比 • 无营销话术',
  'comparison.earningsLabel': '你的月收入（美元）',
  'comparison.savingsYearly': '基于月入${amount} — 即每年${yearly}回到你的口袋。',
  'comparison.savingsVs': '对比 OnlyFans（${onlyfans}）· Throne（${throne}）· Linktree（${linktree}）',
  'comparison.adjustCalc': '在计算器调整 ↓',
  'comparison.breakdown.title': '逐项功能对比',
  'comparison.table.feature': '功能',
  'comparison.table.swipe': '滑动查看更多',
  'comparison.card.countries.title': '195个以上国家',
  'comparison.card.countries.body': '没有银行账户？没问题。Bitcoin为每个人在各地运作。无歧视。',
  'comparison.card.countries.throne': 'Throne：约10个国家0%手续费',
  'comparison.card.countries.katoa': 'KATOA：所有国家，0%（至2026年12月31日）',
  'comparison.card.privacy.title': '真正隐私',
  'comparison.card.privacy.body': '最少采集。非托管。加密消息为可选（NIP-17）。零知识证明在路线图上。',
  'comparison.card.privacy.others': '其他：你的数据是他们的产品',
  'comparison.card.privacy.katoa': 'KATOA：非托管、最少数据',
  'comparison.card.instant.title': '快速结算（路线图）',
  'comparison.card.instant.body': '保留100%收入。全球扩展。无平台税地建立你的帝国。',
  'comparison.card.instant.others': '其他：等待7-14天付款',
  'comparison.card.instant.katoa': 'KATOA：即时闪电网络（支持闪电网络接收 — 见路线图）',
  'comparison.cta.title': '准备好保留100%了吗？',
  'comparison.cta.subtitle': '趁早加入。平台手续费0%。支持者打出的金额归你——Lightning网络费用仍单独存在。',
  'comparison.cta.start': '开始赚取100%',
  'comparison.cta.pricing': '查看定价（剧透：$0）',
  'comparison.cat.fees': '费用与成本',
  'comparison.cat.banking': '银行要求',
  'comparison.cat.global': '全球覆盖',
  'comparison.cat.payout': '付款速度',
  'comparison.cat.revenue': '收入模式',
  'comparison.cat.privacy': '隐私与安全',
  'comparison.cat.payment': '支付功能',
  'comparison.cat.control': '平台控制',
  'comparison.feat.platformFees': '平台手续费',
  'comparison.feat.paymentProcessing': '支付处理',
  'comparison.feat.totalFee10k': '1万美元总费用',
  'comparison.feat.monthlySub': '月订阅',
  'comparison.feat.withdrawalFees': '提现手续费',
  'comparison.feat.hiddenCosts': '隐藏成本',
  'comparison.feat.bankRequired': '需要银行账户',
  'comparison.feat.kyc': 'KYC/身份验证',
  'comparison.feat.noBanking': '无需银行即可使用',
  'comparison.feat.processorDep': '依赖支付处理器',
  'comparison.feat.countries': '支持国家',
  'comparison.feat.sanctioned': 'Bitcoin全球可用',
  'comparison.feat.instantIntl': '快速国际转账（路线图）',
  'comparison.feat.conversion': '货币兑换费',
  'comparison.feat.payoutTime': '付款时间',
  'comparison.feat.instantSettlement': '快速结算（路线图）',
  'comparison.feat.holdback': '资金扣留',
  'comparison.feat.crowdfunding': '众筹/项目',
  'comparison.feat.subscriptions': '订阅（演示）',
  'comparison.feat.tips': '打赏/捐赠',
  'comparison.feat.digital': '数字产品',
  'comparison.feat.fulfillment': '需要履行',
  'comparison.feat.zk': '零知识证明（路线图）',
  'comparison.feat.encrypted': '加密消息（可选 NIP-17）',
  'comparison.feat.decentralized': '去中心化基础设施',
  'comparison.feat.censorship': '抗审查',
  'comparison.feat.micro': '微支付支持',
  'comparison.feat.bolt12': 'BOLT 12定期支付（计划中）',
  'comparison.feat.lightning': 'Lightning Network',
  'comparison.feat.multiRevenue': '多种收入来源',
  'comparison.feat.suspension': '账户封禁风险',
  'comparison.feat.contentCensor': '内容审查',
  'comparison.feat.ownData': '拥有你的数据',
  'comparison.feat.ownKeys': '拥有你的密钥',

  'comparison.cell.instant': '快速',
  'comparison.cell.none': '无',
  'comparison.cell.varies': '视情况',
  'comparison.cell.included': '已包含',
  'comparison.cell.limited': '有限',
  'comparison.cell.demo': '演示',
  'comparison.cell.planned': '计划中',
  'comparison.cell.roadmap': '路线图',

  'comparison.metaTitle': '平台对比',
  'comparison.metaDesc': '对比 KATOA 与 OnlyFans、Throne、Kickstarter 等。平台抽成 0%、闪电网络结算、开始无需 KYC。',
} as const;